/**
 * @generated SignedSource<<b1f7a10be3b9020c924359cfe6f9e5b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoListItemAssignedUsers_todo$data = {
  readonly assigned: ReadonlyArray<{
    readonly assignedAt: string | null;
    readonly employee: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ListItemAssignees_employees">;
    } | null;
  }>;
  readonly assignedRoles: ReadonlyArray<{
    readonly role: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ListItemAssignees_roles">;
    };
  }>;
  readonly " $fragmentType": "TodoListItemAssignedUsers_todo";
};
export type TodoListItemAssignedUsers_todo$key = {
  readonly " $data"?: TodoListItemAssignedUsers_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemAssignedUsers_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemAssignedUsers_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedEmployee",
      "kind": "LinkedField",
      "name": "assigned",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assignedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employee",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ListItemAssignees_employees"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ListItemAssignees_roles"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "227836a8098830f606f736e0fa3a3daf";

export default node;
